import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import moment from 'moment-timezone';
import { Panel } from 'primereact/panel';
import { Link, withRouter } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Paginator from '../../components/Paginator';
import SuperlinkListHeader from './SuperlinkListHeader';
import { sortUrl, toSortOrder, parse } from '../../utils/UrlUtil';

const messages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'name' },
  template: { id: 'attrs.assessmentTemplate', defaultMessage: 'Assessment Template' },
  status: { id: 'attrs.status', defaultMessage: 'Status' },
  createdOn: { id: 'attrs.createdOn', defaultMessage: 'Created on' },
  createdBy: { id: 'attrs.createdBy', defaultMessage: 'Created by' },
  dataNotAvailable: {
    id: 'consumption.account_consumption.data_table.body.dataNotAvailable',
    defaultMessage: 'Data not available',
  },
});

const superlinkStatus = (entity) => {
  const isFinish = entity.totalAssessment === entity.totalFinalStateAssessment;
  return (
    <span className={isFinish ? 'filter filter--success is-active' : 'filter filter--warning is-active'}>
      {`${entity.totalFinalStateAssessment} / ${entity.totalAssessment}`}
    </span>
  );
};

const nameTemplate = (rowData, { currentAccount, keyField, displayField }) => {
  const detailUrl = `/accounts/${currentAccount}/super-links/${rowData[keyField]}`;
  return (
    <Link to={detailUrl} className="app-link">
      {rowData[displayField]}
    </Link>
  );
};

const timeFieldTemplate = (rowData, { formatDate, field }) => {
  const created = formatDate(moment(rowData[field]), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return created;
};

const createdByFieldTemplate = (rowData, { formatMessage }) => {
  if (rowData.createdBy) {
    return `${rowData.createdBy.firstName} ${rowData.createdBy.lastName}`;
  }

  return <span>{formatMessage(messages.dataNotAvailable)}</span>;
};

class SuperlinkList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage, formatDate },
      currentAccount,
      loading,
      location,
    } = this.props;

    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
      template: node.assessmentTemplate.title,
      status: superlinkStatus(node),
    }));

    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;

    // header
    const nameHeader = formatMessage(messages.name);
    const templateHeader = formatMessage(messages.template);
    const statusHeader = formatMessage(messages.status);
    const createdOnHeader = formatMessage(messages.createdOn);
    const createdByHeader = formatMessage(messages.createdBy);

    // footer
    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Panel>
              <div className="p-grid">
                <div className="p-col-12">
                  <SuperlinkListHeader />
                </div>
                <div className="p-col-12 align-center">
                  <DataTable
                    value={listRows}
                    responsive
                    sortField={sortBy}
                    sortOrder={toSortOrder(sortDir)}
                    onSort={this.onSortChange}
                    lazy
                    loading={loading}
                    autoLayout
                  >
                    <Column
                      field="name"
                      header={nameHeader}
                      body={nameTemplate}
                      keyField="id"
                      displayField="name"
                      currentAccount={currentAccount}
                      sortable
                      style={{ textAlign: 'left' }}
                    />
                    <Column
                      field="template"
                      header={templateHeader}
                      sortable
                    />
                    <Column
                      field="createdBy"
                      header={createdByHeader}
                      body={createdByFieldTemplate}
                      formatMessage={formatMessage}
                    />
                    <Column
                      field="status"
                      header={statusHeader}
                    />
                    <Column
                      field="createdOn"
                      header={createdOnHeader}
                      body={timeFieldTemplate}
                      formatDate={formatDate}
                      sortable
                    />
                  </DataTable>
                </div>
                <div className="p-col-12 align-center">{footer}</div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

SuperlinkList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(SuperlinkList));
